{
    "CmeList_Column_ID": "ID",
    "CmeList_Column_Description": "Descrizione",
    "CmeList_Column_ChildCMEs": "ECM",
    "CmeList_Column_TelSyss": "Server di telefonia",
    "CmeList_Column_Partitions": "Pareti divisorie",
    "CmeList_Column_Users": "Utenti",
    "CmeList_CountLink_TelSyssAria": "Server di telefonia aperti filtrati per questo ambiente CM",
    "CmeList_CountLink_PartitionsAria": "Codici aperti filtrati per questo ambiente CM",
    "CmeList_CountLink_UsersAria": "Utenti dell'applicazione aperta filtrati per questo ambiente CM",
    "NAME": "CmeListLanguage"
}